<app-spinner [isLoading]="isLoading"></app-spinner>
<p-toast />

<!-- @if (!hideOwnSearchBar) { -->
<div class="search-bar-container  hide-on-print"
  [ngClass]="(itemId && (selectedImageName || data) ) ? 'justify-content-end search-bar-left' : 'justify-content-center'">
  <!-- <app-search-component [placeHolder]="'Search for an item in smart store'" [isNotFound]="isDataNotFound"
    (onSearchClick)="onSearchParcel($event)" class="hide-on-print w-full md:w-6 lg:w-6 gap-2"
  [class.hidden]="!showRightPanel" [itemId]="itemId"></app-search-component> -->
</div>
<!-- } -->

<div class=" grid mt-2 main-grid hide-on-print" [class.main-grid-expand]="!showRightPanel">
  <div class="left-panel" [ngClass]="(itemId && (data)) ? 'left-panel-onItem' : ''" [class.expand]="!showRightPanel"
    [class.full-width]="!showRightPanel">
    <div>

      <!-- File Viewer -->
      @if (selectedImageName && viewerActive) {
        <app-file-viewer [itemId]="itemId || ''" [fileName]="selectedImageName" [fileUrl]="selectedImageUrl"
        [fromTab]="'TTab'"></app-file-viewer>
      }
      @if (isImageNotFound) {
        <div class="no-image-container">
          <img src="../../../../../assets/images/no-image.jpg" alt="image not found ">
        </div>
      }

    </div>

  </div>
  <span>
    <button type="button" class="default-max-win toggle-btn" [class.toggle-btn-expand]="!showRightPanel" pInputText
      [pTooltip]="showRightPanel?'Expand':'Collapse'" [tooltipPosition]="showRightPanel?'top':'left'"
      (click)="showRightPanel = !showRightPanel" [class.hidden]="!selectedImageName">
      <span [class]="showRightPanel?'pi pi-window-maximize':'pi pi-window-minimize'"></span>
    </button>
  </span>
  @if (showRightPanel) {
    <div class="right-panel hide-on-print">
      @if (data) {
        <div class="parcel-version-div" style="margin-top: 20px;">
          <!-- Images list -->
          <div class="card">
            <p-table [value]="products" dataKey="id" [expandedRowKeys]="expandedRows" size="small">
              <ng-template #header pTemplate="header">
                <tr>
                  <th style="width: 5rem"></th>
                  <th>Terminal </th>
                  <th>Date </th>
                </tr>
              </ng-template>
              <ng-template #body pTemplate="body" let-product let-expanded="expanded">
                <tr>
                  <td>
                    <p-button type="button" pRipple [pRowToggler]="product" [text]="true" [rounded]="true"
                      [plain]="true" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" />
                    </td>
                    <td>{{product.terminals[0]['terminal']}}</td>
                    <td>{{product.timestamp}}</td>
                  </tr>
                </ng-template>
                <ng-template #expandedrow pTemplate="rowexpansion" let-product>
                  <tr>
                    <td colspan="7">
                      <div class="p-3">
                        <p-table [value]="product.terminals[0].images" dataKey="id"
                          styleClass="inner-table" size="small"
                          [paginator]="product.terminals[0].images.length > 5 ? true: false" [rows]="5"
                          [first]="first" [showCurrentPageReport]="true"
                          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                          <ng-template #header pTemplate="header">
                            <tr>
                              <th>Images</th>
                            </tr>
                          </ng-template>
                          <ng-template #body pTemplate="body" let-image>
                            <tr>
                              <td>
                                <a href="javascript:void(0)" class="text-to-button" (click)="selectImage($event, image)"
                                  [class.selected]="(currentImage.id == image.id) && !isBestImage">
                                  Image / {{image.sortingMachine}} / {{ image.tunnel }} / {{ image.camera }}
                                </a>
                              </td>
                            </tr>
                          </ng-template>
                          <ng-template #emptymessage pTemplate="emptymessage">
                            <tr>
                              <td colspan="6">There are no Images.</td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        }
      </div>
    }
  </div>